"use strict";

function _typeof(obj) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) {
    return typeof obj;
  } : function (obj) {
    return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
  }, _typeof(obj);
}

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _styledComponents = _interopRequireDefault(require("../../../utils/styled-components"));

var _styleGenerators = require("../../../utils/styleGenerators");

var React = _interopRequireWildcard(require("react"));

var _Text = _interopRequireDefault(require("../../Text"));

var _fieldItem = _interopRequireDefault(require("../fieldItem"));

var _withTemplateInput = _interopRequireDefault(require("../../../hoc/withTemplateInput"));

var _excluded = ["input", "label", "name", "className", "icon", "style", "onChange", "value", "inputRef", "disabled", "error", "htmlType", "fieldClass"];

var _templateObject, _templateObject2, _templateObject3;

function _getRequireWildcardCache(nodeInterop) {
  if (typeof WeakMap !== "function") return null;
  var cacheBabelInterop = new WeakMap();
  var cacheNodeInterop = new WeakMap();
  return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) {
    return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
  })(nodeInterop);
}

function _interopRequireWildcard(obj, nodeInterop) {
  if (!nodeInterop && obj && obj.__esModule) {
    return obj;
  }

  if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return {
      "default": obj
    };
  }

  var cache = _getRequireWildcardCache(nodeInterop);

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

  for (var key in obj) {
    if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }

  newObj["default"] = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};

  var target = _objectWithoutPropertiesLoose(source, excluded);

  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

function _taggedTemplateLiteral(strings, raw) {
  if (!raw) {
    raw = strings.slice(0);
  }

  return Object.freeze(Object.defineProperties(strings, {
    raw: {
      value: Object.freeze(raw)
    }
  }));
}

var StyledInput = _styledComponents["default"].input(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  width: 100%;\n  padding-right: 30px;\n  letter-spacing: 0;\n  text-decoration: none;\n  box-sizing: border-box;\n  border: none;\n  border-radius: 0;\n  border-bottom-width: 1px;\n  border-bottom-style: solid;\n  background: transparent;\n  padding: 10px 0px;\n"])));

var StyledInputSuffix = _styledComponents["default"].div(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  right: 0px;\n  height: 100%;\n  & > img,\n  & > i {\n    height: 100%;\n  }\n"])));

var StyledTextInput = (0, _styledComponents["default"])(function (_ref) {
  var input = _ref.input,
      label = _ref.label,
      name = _ref.name,
      className = _ref.className,
      icon = _ref.icon,
      style = _ref.style,
      onChange = _ref.onChange,
      value = _ref.value,
      inputRef = _ref.inputRef,
      disabled = _ref.disabled,
      error = _ref.error,
      htmlType = _ref.htmlType,
      fieldClass = _ref.fieldClass,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement(_fieldItem["default"], {
    type: input.title,
    label: label,
    className: fieldClass
  }, /*#__PURE__*/React.createElement("div", {
    className: className
  }, /*#__PURE__*/React.createElement(StyledInput, _extends({}, props, {
    name: name || "",
    type: htmlType,
    className: className,
    value: value,
    style: style,
    onChange: onChange,
    placeholder: props.placeholder,
    ref: inputRef,
    disabled: disabled
  })), icon && /*#__PURE__*/React.createElement(StyledInputSuffix, null, icon)), error && /*#__PURE__*/React.createElement(_Text["default"], {
    type: input.error
  }, error));
})(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n  ", "\n"])), function (_ref2) {
  var _ref2$input = _ref2.input,
      field = _ref2$input.field,
      placeholder = _ref2$input.placeholder;
  var inputStyles = [];

  if (field) {
    inputStyles.push((0, _styleGenerators.styleObjectToString)(field));
  }

  if (placeholder) {
    inputStyles.push((0, _styleGenerators.styleObjectToCSSString)('::-webkit-input-placeholder', placeholder));
    inputStyles.push((0, _styleGenerators.styleObjectToCSSString)('::-moz-placeholder', placeholder));
    inputStyles.push((0, _styleGenerators.styleObjectToCSSString)(':-ms-input-placeholder', placeholder));
    inputStyles.push((0, _styleGenerators.styleObjectToCSSString)('::placeholder', placeholder));
  }

  return inputStyles.join();
});

var _default = (0, _withTemplateInput["default"])(StyledTextInput);

exports["default"] = _default;